/* Copyright (c)2023 Sky Co., LTD. All rights reserved. */
import * as schema from '@/models/Mobile/Android/AndroidManagementV1Schema'


/**
 * Androidのアプリケーション情報をラップするクラス
 */
export class AndroidApplicationWrapper {

    // Androidのアプリケーション情報
    public appData = new schema.AMAPI_Application();

    // SKYSEAMDMアプリかどうか
    public isMDMApp = false;
}

/* Copyright (c)2023 Sky Co., LTD. All rights reserved. */
